import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { SdbTeam } from "@custom-types/teams-types";
import { useTeamMenuOptions } from "@pages/members/teams/use-team-menu-options";

interface Props {
  /** The team to show options for */
  team: SdbTeam;
}

/**
 * Renders a 3-dot menu with actions for a single team row in the table.
 */
export function TeamOptionsMenu({ team }: Props): JSX.Element {
  const menuItems = useTeamMenuOptions();

  return <ListItemMenu<SdbTeam> item={team} menuItems={menuItems} />;
}
